export default __webpack_public_path__ + "static/media/zarin.286065b3.webp";